var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-img',{attrs:{"alt":_vm.categoria.descripcion,"src":_vm.categoria.image},on:{"click":function($event){return _vm.goToProducts(_vm.categoria)}}}),_c('v-card-actions',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }